import React from "react";

interface FormDebugProps {
  values: object;
  errors: object;
  isDirty: boolean;
  isValid: boolean;
  isSubmitting: boolean;
  isSubmittable: boolean;
}

const dump = (o: unknown) => JSON.stringify(o, null, 1).replace(/\n/g, " ");

export const FormDebug: React.FC<FormDebugProps> = ({
  values,
  errors,
  isDirty,
  isValid,
  isSubmittable,
  isSubmitting,
}) => {
  const valuesString = dump(values);
  const stateString = dump({
    errors,
    isDirty,
    isValid,
    isSubmittable,
    isSubmitting,
  });

  return (
    <div
      className="show-administrator"
      style={{
        whiteSpace: "pre-wrap",
        fontSize: "11px",
        backgroundColor: "#f0f0f0",
        padding: "10px",
        borderRadius: "5px",
      }}
    >
      {`values: ${valuesString}\n`}
      {`state: ${stateString}\n`}
    </div>
  );
};
